<template>
  <div class="about">
    <h1>This is an about page</h1>
    <NavButton dest="Intro"/>
  </div>
</template>
<script>
export default {
  name: 'About',
  components: {
  }
}
</script>
